export const pluralize = (count: number) => (count !== 1 ? "s" : "");
